<div mat-dialog-title>
    <div *ngIf="(headerLabel=='WARNING') || warning" style="margin:0;color: #b71c1c; "
        [style.text-align]="headerCenterAlign ? 'center': 'unset'">
        {{headerLabel | translate}}
    </div>
    <div style="float: right;" *ngIf="showSteps" translate>
        {{showSteps | translate}}
    </div>

    <div *ngIf="(headerLabel != 'WARNING') && !warning" style="padding-top: 3px;"
        [style.text-align]="headerCenterAlign ? 'center': 'unset'">
        {{headerLabel | translate}}
    </div>
</div>

<mat-dialog-content>
    <tyl-quill-text-only [padding]="0" [html]="confirmMessage | translate"></tyl-quill-text-only>

    <div *ngIf="showProceed" style="position:relative; bottom:0px; padding-top:10px;">
        <span translate>Proceed?</span>
    </div>

    <div *ngIf="secondMessage" style="padding-top: 10px;padding-bottom: 20px;">
        {{secondMessage | translate}}
    </div>
</mat-dialog-content>

<mat-dialog-actions>
    <div class="flex-footer-left">
        <tyl-button *ngIf="showSteps != null" id="previousButton" image="previous arrow.png" [label]="backButtonLabel"
            (clickEvent)="backClick()"></tyl-button>

    </div>
    <div class="flex-footer-right">
        <tyl-button *ngIf="!disableConfirmation && !informational" id="okDeleteButton" [attr.tylerastid]="okTylerAstId"
            [image]="okButtonImage" [label]="okButtonLabel" (clickEvent)="okClick()"></tyl-button>
        <tyl-button id="cancelDeleteButton" image="cancel.png" [attr.tylerastid]="closeTylerAstId"
            [label]="(informational) ? 'Close' : 'Cancel'" (clickEvent)="cancelClick()"></tyl-button>
    </div>

</mat-dialog-actions>